<fc-general-modal
  [baseId]="baseId"
  [mode]="mode"
  [isSaveDisabled]="!form.dirty"
  [form]="form"
  [listItemName]="listItemName"
  (saveForm)="onSave()"
  (cancelForm)="onCancel()"
>
  <div [formGroup]="form">
    <div class="flex-row-generic">
      <div class="form-group flex-item-two-columns form-group">
        <label for="{{ baseId }}-employer" translate>Employer</label>
        <ap-findcontrol
          id="{{ baseId }}-employer"
          controlName="EmployerUid"
          findControlDisplayName="Find Employer"
          [baseId]="baseId"
          [form]="form"
          [apFormGroup]="form"
          [formGroupSubmitted]="isSubmitted"
          [required]="getFindControlValidation('EmployerUid')"
          (chipsChange)="onEmployerChanged($event)"
          [singleSelect]="true"
          [(selectedPks)]="employerPks"
          [findControlId]="FindControlIdService.ViewEmployer"
          (dirty)="employerUidControl.markAsDirty()"
        >
        </ap-findcontrol>
      </div>
      <div class="form-group flex-item-two-columns form-group">
        <label for="{{ baseId }}-employment-status" translate>Employment Status</label>
        <ap-findcontrol
          id="{{ baseId }}-employment-status"
          controlName="EmploymentStatusUid"
          findControlDisplayName="Find Employment Status"
          [baseId]="baseId"
          [form]="form"
          [apFormGroup]="form"
          [formGroupSubmitted]="isSubmitted"
          [required]="getFindControlValidation('EmploymentStatusUid')"
          (chipsChange)="onEmploymentChanged($event)"
          [singleSelect]="true"
          [(selectedPks)]="employmentStatusPks"
          [findControlId]="FindControlIdService.ListEmploymentStatus"
          (dirty)="employmentStatusUidControl.markAsDirty()"
        >
        </ap-findcontrol>
      </div>
      <div class="form-group flex-item-two-columns form-group">
        <label for="{{ baseId }}-occupation" translate>Occupation</label>
        <ap-findcontrol
          id="{{ baseId }}-occupation"
          controlName="OccupationUid"
          findControlDisplayName="Find Occupation"
          [baseId]="baseId"
          [form]="form"
          [apFormGroup]="form"
          [formGroupSubmitted]="isSubmitted"
          [required]="getFindControlValidation('OccupationUid')"
          (chipsChange)="onOccupationChanged($event)"
          [singleSelect]="true"
          [(selectedPks)]="occupationPks"
          [findControlId]="FindControlIdService.ListOccupation"
          (dirty)="occupationUidControl.markAsDirty()"
        >
        </ap-findcontrol>
      </div>
      <div class="form-group flex-item-two-columns form-group">
        <label for="{{ baseId }}-industry" translate>Industry</label>
        <ap-findcontrol
          id="{{ baseId }}-industry"
          controlName="IndustryUid"
          findControlDisplayName="Find Industry"
          [baseId]="baseId"
          [form]="form"
          [apFormGroup]="form"
          [formGroupSubmitted]="isSubmitted"
          [required]="getFindControlValidation('IndustryUid')"
          (chipsChange)="onIndustryChanged($event)"
          [singleSelect]="true"
          [(selectedPks)]="industryPks"
          [findControlId]="FindControlIdService.ListIndustry"
          (dirty)="industryUidControl.markAsDirty()"
        >
        </ap-findcontrol>
      </div>
      <div class="flex-item-fill form-group">
        <label for="{{ baseId }}-department" translate>Department</label>
        <input
          id="{{ baseId }}-department"
          class="form-control"
          type="text"
          formControlName="Department"
          (input)="onDepartmentChange()"
          [ngClass]="{ error: showErrors(departmentControl, isSubmitted), 'required': isRequired(departmentControl) }"
          [maxlength]="fcListValidation.validations.Department?.MaxLength"
        />
        <div
          *ngIf="showErrors(departmentControl, isSubmitted)"
          id="{{ baseId }}-warning-text-era-payer-id"
          class="incorrect-input"
          translate
        >
          {{ departmentControl.errors | fcListValidation : 'ERA Payer ID' }}
        </div>
      </div>
      <div class="flex-item-fill employed-from">
        <h6>Employed From</h6>
      </div>
      <div class="flex-item-two-columns form-group">
        <label for="{{ baseId }}-start-date" translate>Start Date</label>
        <ap-timeframe
          controlName="startDateControl"
          [baseId]="baseId + '-start-date'"
          [visitId]="item.Id"
          [patientId]="item.Id"
          [nonSelectableTimeFrames]="[]"
          [timeframe]="startTimeFrame"
          (timeframeChanged)="onStartTimeFrameChanged($event)"
          (timeframeChangeInprogress)="onStartDateTimeframeChangeInprogressChanged($event)">
        </ap-timeframe>
      </div>
      <div class="flex-item-two-columns form-group">
        <label for="{{ baseId }}-end-date" translate>End Date</label>
        <ap-timeframe
          controlName="endDateControl"
          [baseId]="baseId + '-end-date'"
          [visitId]="item.Id"
          [patientId]="item.Id"
          [nonSelectableTimeFrames]="[]"
          [timeframe]="endTimeFrame"
          (timeframeChanged)="onEndTimeFrameChanged($event)"
          (timeframeChangeInprogress)="onEndDateTimeframeChangeInprogressChanged($event)">
        </ap-timeframe>
      </div>
    </div>
  </div>
</fc-general-modal>
